import { eventContentIssues, type ProcessDraftEventNode } from '@bliks-io/contracts';

/**
 * Mirrors `getDisabledReasons` for the start-recording page: returns the i18n
 * keys for every requirement the start configuration is still missing, so the
 * bottom bar's tooltip can list them and the same array drives the disabled
 * state — the two can never disagree.
 */
export function getStartDisabledReasons(
  startEvent: Pick<ProcessDraftEventNode, 'name' | 'description' | 'eventKind'> | null | undefined,
  hasStartAttachedNode: boolean
): string[] {
  const reasons: string[] = [];

  // Publish's own start-event rules. The name also distinguishes the
  // minted-empty placeholder from a configured start event — `eventType: 'none'`
  // is itself a legitimate, user-selectable BPMN start type.
  const hasValidStartEvent = !!startEvent && eventContentIssues(startEvent).length === 0;
  if (!hasValidStartEvent) {
    reasons.push('recording.startDisabled.missingStartEvent');
  }

  // Page-only rule: publish accepts a draft without a first step, but then
  // nothing starts.
  if (!hasStartAttachedNode) {
    reasons.push('recording.startDisabled.missingSuccessor');
  }

  return reasons;
}
